import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Suppress Firebase development console warnings and errors
const originalWarn = console.warn;
const originalLog = console.log;
const originalError = console.error;

const shouldSuppressMessage = (message) => {
  return (
    message.includes('Cross-Origin-Opener-Policy') ||
    message.includes('window.closed') ||
    message.includes('stagewise') ||
    message.includes('discovery mechanism') ||
    message.includes('IDE windows found') ||
    message.includes('ping/stagewise') ||
    message.includes('ERR_CONNECTION_REFUSED')
  );
};

console.warn = (...args) => {
  const message = args.join(' ');
  if (shouldSuppressMessage(message)) {
    return;
  }
  originalWarn.apply(console, args);
};

console.log = (...args) => {
  const message = args.join(' ');
  if (shouldSuppressMessage(message)) {
    return;
  }
  originalLog.apply(console, args);
};

console.error = (...args) => {
  const message = args.join(' ');
  if (shouldSuppressMessage(message)) {
    return;
  }
  originalError.apply(console, args);
};

const firebaseConfig = {
  apiKey: 'AIzaSyB0CRj0BGhqTJOMuoqdgAIUmjnioNoKBtc',
  authDomain: 'agents-f3a7e.firebaseapp.com',
  projectId: 'agents-f3a7e',
  storageBucket: 'agents-f3a7e.firebasestorage.app',
  messagingSenderId: '795721881314',
  appId: '1:795721881314:web:cdb95e9dfde9cfe279f0bb',
  measurementId: 'G-73QGFHJY07'
};

// Initialize Firebase services
let app;
let auth;
let db;
let analytics;
let googleProvider;

try {
  // Initialize Firebase
  app = initializeApp(firebaseConfig);
  
  // Initialize Firebase Analytics (only on production - www.44agents.com)
  if (typeof window !== 'undefined' && window.location.hostname === 'www.44agents.com') {
    try {
      analytics = getAnalytics(app);
    } catch (analyticsError) {
      console.warn('Firebase Analytics initialization failed:', analyticsError);
      analytics = null;
    }
  } else {
    analytics = null;
  }
  
  // Initialize Firebase Auth with local persistence
  auth = getAuth(app);
  
  // Set persistence to LOCAL to maintain auth state across browser sessions
  setPersistence(auth, browserLocalPersistence)
    .then(() => {
      console.log('Firebase Auth persistence set to LOCAL');
    })
    .catch((error) => {
      console.error('Error setting Firebase Auth persistence:', error);
    });
  
  // Initialize Firestore
  db = getFirestore(app);
  
  // Initialize Google Auth Provider with required scopes
  googleProvider = new GoogleAuthProvider();
  googleProvider.addScope('email');
  googleProvider.addScope('profile');
  googleProvider.setCustomParameters({
    prompt: 'select_account'
  });
  
} catch (error) {
  // Firebase initialization failed
  console.error('Firebase initialization failed:', error);

  // Set services to null so the app can detect and handle missing services
  app = null;
  auth = null;
  db = null;
  analytics = null;
  googleProvider = null;
}

// Export Firebase services
export { auth, db, analytics, googleProvider };

// Type declarations for TypeScript
export const getDb = () => db;
export const isDbInitialized = () => !!db; 